module.exports = __webpack_public_path__ + "img/18286887_water_the_plant.73b5351d.jpg";